import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useMemo, useState } from 'react';

import { copyProjectGql } from '../projectCopyQueries';

export const useCopyProject = (uniqueId?: string) => {
    const variables = useMemo(() => (uniqueId ? { uniqueId } : null), [uniqueId]);

    const [isSubmitted, setIsSubmitted] = useState(false);

    const [copyProjectData, copyProjectStatus, copyProjectError, copyProjectMakeRequest] = useRequest({
        requestId: 'copyProject',
        query: copyProjectGql,
        withEffect: false,
    });

    const [makeResetCopyProject] = useResetStoreData({ requestId: 'copyProject' });

    const reset = useCallback(() => {
        setIsSubmitted(false);
        makeResetCopyProject(null);
    }, [makeResetCopyProject]);

    const onCreateReportDownload = useCallback(() => {
        ExportCSVReport(copyProjectData?.copyProject?.validation);
    }, [copyProjectData?.copyProject?.validation]);

    return {
        copyProjectStatus,
        copyProjectError,
        copyProjectData,
        reset,
        isSubmitted,
        setIsSubmitted,
        onCreateReportDownload,
        variables,
        copyProjectMakeRequest,
    };
};
